import memoize from "lodash/memoize";

// Intl constructors are expensive relative to format(); reuse instances.
export const getDateTimeFormat = memoize(
  (locale: string, options: Intl.DateTimeFormatOptions) =>
    new Intl.DateTimeFormat(locale, options),
  (locale, options) => `${locale}|${JSON.stringify(options)}`,
);

export const getRelativeTimeFormat = memoize(
  (locale: string, options: Intl.RelativeTimeFormatOptions) =>
    new Intl.RelativeTimeFormat(locale, options),
  (locale, options) => `${locale}|${JSON.stringify(options)}`,
);
